<div class="filters row">
  <div class="row">
    <div class="r-form-group">
      <label class="title">{{ 'LIDS.START_DATE' | translate }}</label>
      <p-calendar [(ngModel)]="createdAtRange" [selectionMode]="'range'" dateFormat="dd/mm/yy" [showButtonBar]="true"
        [clearButtonStyleClass]="'clear-button'" (onSelect)="filterCreatedDate()" (onClearClick)="filterCreatedDate()">
      </p-calendar>
    </div>

    <div class="r-form-group">
      <label class="title">{{ 'LIDS.END_DATE' | translate }}</label>
      <p-calendar [(ngModel)]="expireAtRange" [selectionMode]="'range'" dateFormat="dd/mm/yy" [showButtonBar]="true"
        [clearButtonStyleClass]="'clear-button'" (onSelect)="filterCreatedDate()" (onClearClick)="filterCreatedDate()">
      </p-calendar>
    </div>
    <div class="r-form-group">
      <label class="title">{{'BUSINESS_COUPON.STATUS' | translate}}</label>
      <p-dropdown [options]="translatedStatusOptions" [(ngModel)]="selectedStatus" optionLabel="label"
        optionValue="value" placeholder="{{'BUSINESS_COUPON.STATUS' | translate}}" [showClear]="true"
        (onClear)="filterStatus()" (onChange)="filterStatus()">
      </p-dropdown>
    </div>

  </div>
  <div class="r-form-group totalRecords">{{totalRecords}} {{'BUSINESS_COUPON.COUNT_BUSINESS_COUPONS'|translate}}</div>
  <app-atn-export-excel [request]="request" [fileName]="'BusinessCoupon'"></app-atn-export-excel>
</div>

<div class="table">
  <app-readonly-table #dt [columns]="columns" [selectionMode]="null" [itemsSource$]="businessCoupons$"
    [isFilterable]="false" [scrollable]="true" [paginator]="true" (onLoadData)="onLoadData($event)" [isLoadLazy]="true"
    [totalRecords]="totalRecords" [rowsPerPageOptions]="null">
  </app-readonly-table>
</div>

<ng-template #resendEmailTemplate let-rowData>
  <button pButton type="button" icon="pi pi-envelope" class="p-button-rounded p-button-text resend-email-btn"
    [disabled]="!rowData.customerEmail || !rowData.couponCode"
    pTooltip="{{'BUSINESS_COUPON.RESEND_EMAIL' | translate}}" tooltipPosition="top"
    (click)="resendWinningEmail(rowData.couponCode)">
  </button>
</ng-template>